<template>
	<div>
		<titlebar title="Create Campaign" />
		<CampaignForm :loading="submitting" @submit="onSubmit" />
	</div>
</template>

<script>
import api from '@/mixins/api'
import toast from '@/mixins/toast'
import Titlebar from '@/components/admin/Titlebar'
import CampaignForm from '@/components/admin/CampaignForm'

export default {
	name: 'CreateCampaign',
	data() {
		return {
			submitting: false
		}
	},
	methods: {
		async onSubmit(body) {
			this.submitting = true
			try {
				// Create the campaign
				await this.post('/campaigns', { body })
				this.toast('Successfully *created* the campaign.')

				// Navigate to manage campaigns page
				this.$router.push({ name: 'Manage Campaigns' })
			} catch (err) {
				// Show toast with relevant error
				switch (err.name) {
					case 'APIValidationError':
						this.toastWarn("Please check the campaign's details and try again.")
						break
					default:
						this.toastErr(
							'Failed to create the campaign. Please try again later.'
						)
						break
				}
			}
			this.submitting = false
		}
	},
	mixins: [api, toast],
	components: {
		Titlebar,
		CampaignForm
	}
}
</script>
